import Vue from 'vue'
import Router from 'vue-router'
import Test from './components/Test.vue'
import List from './components/List.vue'
import SettingCrush from './components/SettingCrush.vue'

Vue.use(Router)

export default new Router({
  // デフォルトの挙動では URL に `#` が含まれる.
  // URL から hash を取り除くには `mode:history` を指定する
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'test',
      component: Test,
    },
    {
      path: '/list',
      name: 'list',
      component: List,    
    },
    {
      path: '/settingCrush',
      name: 'settingCrush',
      component: SettingCrush,
      props: (route) => ({
        target: route.params.target,
      }),
    },
    // {
    //   path: '/settingCrush2',
    //   name: 'settingCrush2',
    //   redirect: { name: 'settingCrush' }

    // },
  ],
})
